<template>
  <button @click="getData">获取数据</button>
  <p>{{ tage }}</p>
</template>

<script>
export default {
  data() {
    return {
      dat: '',
      tage: [],
    }
  },
  methods: {
    getData() {
      this.$axios.get("https://www.vilipix.com/api/v1/search/recommand_tag").then(res => {
        console.log(res);
      }).catch(error => {
        console.log(error);
      })

      this.$axios.get("/tage").then(res => {
        console.log(res);
        this.tage = res.data.tagL;
        console.log(this.tage);
      }).catch(error => {
        console.log(error);
      })
    },
  },
};
</script>